<template>
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="main_head">
            <div class="main_head_left">
              <div>
                <div class="input_parent">
                  <el-input
                    class="input"
                    v-model="where_student_no"
                    placeholder="请输入"
                    size
                  ></el-input>
                  <span>学号:</span>
                </div>
                <div class="input_parent">
                  <el-input
                    class="input"
                    v-model="where_name"
                    placeholder="请输入"
                    size
                  ></el-input>
                  <span>姓名:</span>
                </div>
                <div class="input_parent">
                  <el-select
                    class="input"
                    v-model="where_programme"
                    placeholder="请选择"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="item in programmeOptions"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                  <span>专业:</span>
                </div>
                <div class="input_parent">
                  <el-date-picker
                    class="input input_daterange"
                    unlink-panels
                    v-model="where_year"
                    value-format="yyyy"
                    type="monthrange"
                  ></el-date-picker>
                  <span>入学年份:</span>
                </div>
              </div>

              <div v-show="queryMoreShowFlag">
                <div>
                  <div class="input_parent">
                    <el-select
                      class="input"
                      v-model="where_status"
                      placeholder="请选择"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in workStatusOptions"
                        :key="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>状态:</span>
                  </div>
                  <div class="input_parent">
                    <el-cascader
                      class="input input_daterange"
                      v-model="where_region"
                      :options="regionOptions"
                      :props="{ expandTrigger: 'hover' }"
                      @change="handleRegionChange"
                      clearable
                      filterable
                    ></el-cascader>
                    <span>所在地:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_organization"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>单位名称:</span>
                  </div>
                  <div class="input_parent">
                    <el-select
                      class="input"
                      v-model="where_unit_property"
                      placeholder="请选择"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in unitOptions"
                        :key="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>单位性质:</span>
                  </div>
                  <div class="input_parent">
                    <el-select
                      class="input"
                      v-model="where_job_type"
                      placeholder="请选择"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in jobTypeOptions"
                        :key="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>行业类型:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_position"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>工作职位:</span>
                  </div>
                </div>
                <div>
                  <div class="input_parent">
                    <el-select
                      class="input"
                      v-model="where_pay"
                      placeholder="请选择"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in payOptions"
                        :key="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>薪酬范围:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_registered_address"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>公司注册地:</span>
                  </div>
                  <div class="input_parent">
                    <el-select
                      class="input"
                      v-model="where_employees"
                      placeholder="请选择"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in employeesOptions"
                        :key="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>雇员人数:</span>
                  </div>
                  <div class="input_parent">
                    <el-select
                      class="input"
                      v-model="where_turnover"
                      placeholder="请选择"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in turnoverOptions"
                        :key="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>年营业额:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_freelance"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>从事何种自由职业:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_mobile_phone"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>联系电话:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_wechat"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>微信:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_origin_place"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>生源地:</span>
                  </div>
                  <div class="input_parent">
                    <el-select
                      class="input"
                      v-model="where_alumni_type"
                      placeholder="请选择"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in alumniTypeOptions"
                        :key="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>校友类别:</span>
                  </div>
                </div>
                <!-- <div style="clear:both;"></div> -->
              </div>
            </div>
            <div class="main_head_right">
              <el-button type="primary" @click="query()">查询</el-button>
              <el-button @click="reset()">重置</el-button>
              <el-button type="text" @click="queryMoreShow()">{{
                queryMoreShowTitle
              }}</el-button>
              <span
                v-bind:class="[
                  queryMoreShowFlag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                ]"
                @click="queryMoreShow()"
              ></span>
            </div>
          </div>
          <!-- <div style="clear: both"></div> -->
          <div style="clear: both"></div>

          <div style="margin-top: 10px">
            <el-dropdown
              @command="handleDialogCommand"
              placement="bottom-start"
            >
              <el-button>
                <i class="el-icon-s-operation el-icon--left"></i> 批量操作
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="exportSelect"
                  >导出选中信息</el-dropdown-item
                >
                <el-dropdown-item command="exportAisJobInfo"
                  >导出查询列表</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <i
              class="el-icon-setting setTabBabel"
              style="margin-top: 10px"
              @click="showSetTabBabelDrawer()"
            ></i>
          </div>

          <div class="selectTitle" v-if="selectSize > 0">
            <span class="el-icon-info" style="color: #2383e0"></span>
            <span style="margin-left: 10px">已选择</span>
            <span class="selectTitleNum">{{ selectSize }}</span>
            <span>条信息</span>
            <el-button
              type="text"
              class="selectTitleClear"
              @click="cleanTable()"
              >清空</el-button
            >
          </div>

          <el-table
            v-loading="tableLoading"
            ref="multipleTable"
            :data="tableData"
            @row-click="toUserDetails"
            @sort-change="changeTableSort"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" min-width="1"></el-table-column>
            <el-table-column
              prop="student_no"
              v-if="checkList.indexOf('学号') > -1"
              label="学号"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="name_cn"
              v-if="checkList.indexOf('中文姓名') > -1"
              label="中文姓名"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="name_en"
              v-if="checkList.indexOf('英文姓名') > -1"
              label="英文姓名"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="programme"
              v-if="checkList.indexOf('专业') > -1"
              label="专业"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="year"
              v-if="checkList.indexOf('入学年份') > -1"
              label="入学年份"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="status"
              v-if="checkList.indexOf('状态') > -1"
              label="状态"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="location"
              v-if="checkList.indexOf('所在地') > -1"
              label="所在地"
              min-width="3"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="organization"
              v-if="checkList.indexOf('单位名称') > -1"
              label="单位名称"
              min-width="3"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="unit_property"
              v-if="checkList.indexOf('单位性质') > -1"
              label="单位性质"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="job_type"
              v-if="checkList.indexOf('行业类型') > -1"
              label="行业类型"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="position"
              v-if="checkList.indexOf('工作职位') > -1"
              label="工作职位"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="pay"
              v-if="checkList.indexOf('薪酬范围') > -1"
              label="薪酬范围"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="registered_address"
              v-if="checkList.indexOf('公司注册地') > -1"
              label="公司注册地"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="employees"
              v-if="checkList.indexOf('雇员人数') > -1"
              label="雇员人数"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="turnover"
              v-if="checkList.indexOf('年营业额') > -1"
              label="年营业额"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="freelance"
              v-if="checkList.indexOf('从事何种自由职业') > -1"
              label="从事何种自由职业"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="mobile_phone"
              v-if="checkList.indexOf('联系电话') > -1"
              label="联系电话"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="wechat"
              v-if="checkList.indexOf('微信') > -1"
              label="微信"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="origin_place"
              v-if="checkList.indexOf('生源地') > -1"
              label="生源地"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="alumni_type"
              v-if="checkList.indexOf('校友类别') > -1"
              label="校友类别"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="is_bachelors_masters"
              v-if="checkList.indexOf('是否本硕连读') > -1"
              label="是否本硕连读"
              min-width="2"
            ></el-table-column>
          </el-table>
          <div class="elPaginationDiv">
            <el-pagination
              :key="elementui_page_key"
              class="elPagination"
              background
              layout="prev, pager, next"
              :page-size="pageMaxSize"
              :page-count="pageCount"
              :current-page="currentPage"
              @current-change="currentChange"
            ></el-pagination>
            <span class="paginationPageNum"
              >第{{ thispageNum }}条，总共{{ recordCount }}条</span
            >
          </div>
        </el-main>
        <jobs-table-label-drawer
          ref="_jobsTableLabelDrawer"
          @toBackCheckList="backCheckList"
        ></jobs-table-label-drawer>
        <export-ais-job-info-dialog
          ref="_exportAisJobInfoDialog"
        ></export-ais-job-info-dialog>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CRegion from "@/utils/constant_region.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import leftMeun from "@/components/layout/leftMeun";
import headerLayout from "@/components/layout/headerLayout";
import headRight from "@/components/layout/headRight";
import exportAisJobInfoDialog from "@/components/dialog/exportAisJobInfoDialog";
import jobsTableLabelDrawer from "@/components/drawer/jobsTableLabelDrawer";

var multipleSelectionMap = new Map(); // 多页选中数组总数

// table 筛选器
function ScreenOptions(value) {
  this.text = value;
  this.value = value;
}
export default {
  components: {
    leftMeun,
    headerLayout,
    headRight,
    exportAisJobInfoDialog,
    jobsTableLabelDrawer
  },
  data() {
    return {
      tableLoading: false,
      meunItem: null,
      meunTitle: " 工作信息列表",
      queryMoreShowFlag: false,
      queryMoreShowTitle: "展开",
      timeOutTimer: "",
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      pageCount: 0,
      selectSize: 0,
      recordCount: 0,
      thispageNum: "1-" + LIST_PAGE_MAX_SIZE,
      otherPageSelectSize: 0, //其他页选中的数量
      changExcelDialogVisible: false,
      changSiDialogVisible: false,
      changeExportInfoDialog: false,
      exportAisJobInfoRequest: false,

      currentPage: 1,
      order: "",
      where_student_no: "",
      where_name: "",
      where_status: "",
      where_programme: "",
      where_organization_nation: "",
      where_organization_province: "",
      where_organization_city: "",
      where_organization: "",
      where_unit_property: "",
      where_job_type: "",
      where_position: "",
      where_pay: "",
      where_registered_address: "",
      where_employees: "",
      where_turnover: "",
      where_freelance: "",
      where_year: [],
      where_region: "",
      where_mobile_phone: "",
      where_wechat: "",
      where_origin_place: "",
      where_alumni_type: [],

      regionOptions: JSON.parse(localStorage.getItem("options_region")),
      workStatusOptions: Constant.work_status_options,
      unitOptions: Constant.unit_options,
      jobTypeOptions: Constant.job_type_options,
      payOptions: Constant.pay_options,
      turnoverOptions: Constant.turnover_options,
      employeesOptions: Constant.employees_options,
      programmeOptions: Constant.programme_options,
      alumniTypeOptions: [],

      tableData: [],
      multipleSelection: [], // 单页选中数组
      checkList: Constant.jobs_table_lable_base
    };
  },
  mounted() {
    var that = this;
    document.onkeydown = function(e) {
      const keyCode = event.keyCode
        ? event.keyCode
        : event.which
        ? event.which
        : event.charCode;
      // 回车键查询
      if (keyCode == 13) that.query();
    };
  },
  created() {
    this.elementui_page_key++;
    CRegion.regionPutAllOptions(this.regionOptions);
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      // 获取操作日志列表
      this.getAisJobInfo();
      this.getProgrammeOptions();
      this.getAlumniTypeOptions();
    },
    showSetTabBabelDrawer() {
      this.$nextTick(() => {
        this.$refs._jobsTableLabelDrawer.show(this.checkList);
      });
    },
    exportList() {
      let ids = this.getUserIds();
      if (ids.length == 0) {
        this.$message.error("至少选中一条数据");
        return;
      }
      ids = JSON.stringify(ids);
      this.$nextTick(() => {
        this.$refs._exportAisJobInfoDialog.show(
          this.checkList,
          this.order,
          this.where_student_no,
          this.where_name,
          this.where_status,
          this.where_programme,
          this.where_unit_property,
          this.where_job_type,
          this.where_pay,
          this.where_employees,
          this.where_turnover,
          this.where_organization_nation,
          this.where_organization_province,
          this.where_organization_city,
          this.where_organization,
          this.where_position,
          this.where_registered_address,
          this.where_freelance,
          this.where_year,
          this.where_mobile_phone,
          this.where_wechat,
          this.where_origin_place,
          this.where_alumni_type,
          ids
        );
      });
    },
    exportAisJobInfo() {
      if (this.recordCount == 0) {
        this.$message.error("列表无数据，无法导出");
        return;
      }
      this.$nextTick(() => {
        this.$refs._exportAisJobInfoDialog.show(
          this.checkList,
          this.order,
          this.where_student_no,
          this.where_name,
          this.where_status,
          this.where_programme,
          this.where_unit_property,
          this.where_job_type,
          this.where_pay,
          this.where_employees,
          this.where_turnover,
          this.where_organization_nation,
          this.where_organization_province,
          this.where_organization_city,
          this.where_organization,
          this.where_position,
          this.where_registered_address,
          this.where_freelance,
          this.where_year,
          this.where_mobile_phone,
          this.where_wechat,
          this.where_origin_place,
          this.where_alumni_type
        );
      });
    },
    // 查看学生详情 details
    toUserDetails(row, column, event) {
      Api.verifyApi(CApi.api_getAisInfoById, verify => {
        if (verify) {
          this.meunItem.userid = row.id;
          localStorage.setItem("meunItem", JSON.stringify(this.meunItem));
          this.$router.push({path:"/data/user-details",query:{id:row.id}});
        }
      });
    },
    // 选择列表显示字段
    backCheckList(list) {
      this.checkList = list;
    },
    // 批量操作弹窗
    handleDialogCommand(command) {
      let _this = this;
      switch (command) {
        case "exportAisJobInfo":
          Api.verifyApi(CApi.api_exportAisJobInfo, verify => {
            if (verify) {
              this.exportAisJobInfoRequest = true;
              _this.getAisJobInfo();
            }
          });
          break;
        case "exportSelect":
          Api.verifyApi(CApi.api_exportAisJobInfo, verify => {
            if (verify) {
              _this.exportList();
            }
          });
          break;
      }
    },
    // 地区选择
    handleRegionChange(value) {
      this.where_organization_nation = value[0];
      this.where_organization_province = value[1];
      this.where_organization_city = value[2];
    },
    currentChange(val) {
      this.elementui_page_key++;
      this.otherPageSelectSize += this.multipleSelection.length;
      multipleSelectionMap.set(this.currentPage, this.multipleSelection);
      console.log(multipleSelectionMap);

      this.otherPageSelectSize = 0;
      var that = this;
      multipleSelectionMap.forEach(function(key, value, index) {
        if (value != val) {
          that.otherPageSelectSize += key.length;
        }
      });
      this.currentPage = val;
      this.getAisJobInfo();
    },
    // 列表选中监听
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      this.setShowBatchBtnState(this.multipleSelection.length);
    },
    // 排序
    changeTableSort(column) {
      if ("location" == column.prop) {
        this.order = StrUtils.getLocationPropOrder(column, "organization");
      } else {
        this.order = StrUtils.getPropOrder(column);
      }
      this.query();
    },
    // 获取专业
    getProgrammeOptions: function() {
      this.$api
        .getColumnValue({
          token: localStorage.getItem("token"),
          field: "programme"
        })
        .then(({ data }) => {
          this.programmeOptions = data.Data.programme;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 获取校友类别
    getAlumniTypeOptions() {
      this.$api
        .bindAisInfoFieldArr({ field: "alumni_type" })
        .then(({ data }) => {
          this.alumniTypeOptions = data.Data.alumni_type;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 服务端获取数据
    getAisJobInfo: function() {
      this.tableLoading = true;
      this.$api
        .getAisJobInfos({
          token: localStorage.getItem("token"),
          page: this.currentPage,
          limit: this.pageMaxSize,

          order: this.order,
          where_student_no: this.where_student_no,
          where_name: this.where_name,
          where_status: StrUtils.replaceFields(this.where_status.toString()),
          where_programme: StrUtils.replaceFields(
            this.where_programme.toString()
          ),
          where_unit_property: StrUtils.replaceFields(
            this.where_unit_property.toString()
          ),
          where_job_type: StrUtils.replaceFields(
            this.where_job_type.toString()
          ),
          where_pay: StrUtils.replaceFields(this.where_pay.toString()),
          where_employees: StrUtils.replaceFields(
            this.where_employees.toString()
          ),
          where_turnover: StrUtils.replaceFields(
            this.where_turnover.toString()
          ),
          where_alumni_type: StrUtils.replaceFields(
            this.where_alumni_type.toString()
          ),
          where_organization_nation: this.where_organization_nation,
          where_organization_province: this.where_organization_province,
          where_organization_city: this.where_organization_city,
          where_organization: this.where_organization,
          where_position: this.where_position,
          where_registered_address: this.where_registered_address,
          where_freelance: this.where_freelance,
          where_year:
            this.where_year == undefined || this.where_year.length == 0
              ? ""
              : this.where_year[0] + "-" + this.where_year[1],
          where_mobile_phone: this.where_mobile_phone,
          where_wechat: this.where_wechat,
          where_origin_place: this.where_origin_place
        })
        .then(({ data }) => {
          this.recordCount = data.Data.recordCount;
          var currentPage = data.Data.currentPage;
          var startIndex = (currentPage - 1) * this.pageMaxSize + 1;
          var endIndex = startIndex + this.pageMaxSize - 1;
          if (endIndex > this.recordCount) {
            endIndex = this.recordCount;
          }
          this.thispageNum = startIndex + "-" + endIndex;
          this.pageCount = data.Data.pageCount;
          this.tableData = data.Data.model;
          this.tableData.forEach(info => {
            info.location = StrUtils.getJobLocation(info);
            info.is_bachelors_masters = StrUtils.yesOrNo(
              info.is_bachelors_masters
            );
          });
          this.timeOutTimer = setTimeout(this.toggleRowSelectionn, 10);
          this.tableLoading = false;
          if (this.exportAisJobInfoRequest) {
            this.exportAisJobInfo();
          }
          this.exportAisJobInfoRequest = false;
        })
        .catch(({ error }) => {
          this.exportAisJobInfoRequest = false;
          this.tableLoading = false;
          if (error != undefined) {
            console.log(error);
          }
        });
    },
    // 恢复勾选已选中
    toggleRowSelectionn() {
      if (multipleSelectionMap.size == 0) return;
      var array = multipleSelectionMap.get(this.currentPage);
      if (array == undefined || array.length == 0) return;
      var arr = JSON.parse(JSON.stringify(array));
      this.tableData.forEach(tData => {
        arr.forEach(tData1 => {
          if (tData.job_id === tData1.job_id) {
            this.$refs.multipleTable.toggleRowSelection(tData, true);
          }
        });
      });
    },
    // 批量操作显示状态修改
    setShowBatchBtnState(size) {
      this.selectSize = size + this.otherPageSelectSize;
    },
    // 获取选中的用户id 数组
    getUserIds: function() {
      multipleSelectionMap.set(this.currentPage, this.multipleSelection);
      var userIds = [];
      multipleSelectionMap.forEach(function(key, value, index) {
        key.forEach(user => {
          userIds.push(user.job_id);
        });
      });
      return userIds;
    },
    // 查询
    query: function() {
      this.currentPage = 1;
      this.getAisJobInfo();
    },
    // 搜索重置
    reset: function() {
      this.$refs.multipleTable.clearFilter();
      multipleSelectionMap.clear();

      this.order = "";
      this.where_student_no = "";
      this.where_name = "";
      this.where_status = "";
      this.where_programme = "";
      this.where_organization_nation = "";
      this.where_organization_province = "";
      this.where_organization_city = "";
      this.where_organization = "";
      this.where_unit_property = "";
      this.where_job_type = "";
      this.where_position = "";
      this.where_pay = "";
      this.where_registered_address = "";
      this.where_employees = "";
      this.where_turnover = "";
      this.where_freelance = "";
      this.where_year = "";
      this.where_region = "";
      this.where_mobile_phone = "";
      this.where_wechat = "";
      this.where_origin_place = "";
      this.where_alumni_type = [];
      this.exportAisJobInfoRequest = false;
      this.otherPageSelectSize = 0;
      this.setShowBatchBtnState(0);
      this.query();
    },
    queryMoreShow() {
      this.queryMoreShowFlag = !this.queryMoreShowFlag;
      this.queryMoreShowTitle = this.queryMoreShowFlag ? "收起" : "展开";
    },
    //清空已选表格
    cleanTable: function() {
      multipleSelectionMap.clear();
      this.otherPageSelectSize = 0;
      this.setShowBatchBtnState(0);
      this.$refs.multipleTable.clearSelection();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeOutTimer);
  }
};
</script>

<style lang="less" scoped>
.main {
  margin: 10px 20px;
  background-color: #fff;
  border-radius: 5px;
}
.main_head {
  width: 100%;
}
.main_head_left {
  margin-left: -20px;
  width: 85%;
  float: left;
}
.selectTitle {
  padding-left: 10px;
  margin-top: 15px;
  background-color: #eff9fe;
  border-radius: 3px;
  border: 1px solid #2383e0;
  height: 40px;
  line-height: 40px;
}
.selectTitleNum {
  color: #2383e0;
}
.selectTitleClear {
  color: #2383e0;
  margin-left: 20px;
  cursor: hand;
}
</style>

<style lang="less">
.el-date-editor--monthrange.el-input,
.el-date-editor--monthrange.el-input__inner {
  width: 55%;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataMgr/listJobs.vue